import React, { Fragment, useCallback, useEffect, useState } from "react";
import ProfileInfoSection from "../../components/player/profileInfoSection";
import ProfileStatisticsRecentStories from "../../components/player/profileStatistics/profileStatisticsRecentStories";
import ProfileTabSection from "../../components/player/profileTabSection";
import GetRandomInt from "../../common/getRandomValue";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../interfaces/redux";
import { useParams } from "react-router-dom";
import GetActiveLcdData from "../../common/getActiveLcdData";
import axios from "axios";
import {
  getHeaderForAxios,
  getUserData,
} from "../../common/getLocalStorageData";
import { deal_type } from "../../constant/deal";
import TpProfileFirstPositionAdvertise from "../../components/advertise/tpProfileFirstPositionAdvertise";

const intialDetailState: any = {
  detail: {},
  batting: [],
  pitcher: [],
  fileding: [],
  leagueDropdown: [],
  topperDetails: [],
};
const intialAvailableStatistics = {
  get_data: false,
  batting: false,
  fielding: false,
  pitcher: false,
};
export default function TeamProfile() {
  const [teamStatistics, setTeamStatistics] = useState(intialDetailState);
  const [availableStatistics, setAvailableStatistics] = useState(
    intialAvailableStatistics
  );
  const [redirectToNotFound, setRedirectToNotFound] = useState(false);
  const params: any = useParams();
  const globalState = useSelector((state: IReduxStateData) => state);
  const userId = getUserData();
  const [selectStatistics, setSelectStatistics] = useState(0);

  useEffect(() => {
    let globalStateData = GetActiveLcdData(globalState);
    console.log("globalStateData >>", globalStateData);
    // let playersArray = globalStateData && globalStateData.player_identifier ? globalStateData.player_identifier.split(',') : []
    if (
      globalStateData &&
      params?.team_identifier &&
      globalStateData.tp_identifier
        .split(",")
        .includes(params?.team_identifier) &&
      (globalStateData.is_player === deal_type["team_deal"] ||
        globalStateData.is_player === deal_type["teams_deal"])
    ) {
      let data = {
        team_identifier: params?.team_identifier,
        league_uuid: globalStateData?.league_uuid,
      };
      let available_statistics = intialAvailableStatistics;
      const callApi = async () => {
        await axios
          .post(process.env.REACT_APP_API_URL + "/match/getTeamDetail", data, {
            headers: getHeaderForAxios(),
          })
          .then(function (response) {
            // handle success
            if (response.data && response.data.success) {
              let resData = response.data.success;
              available_statistics["get_data"] = true;
              if (resData.batting && resData.batting.length) {
                available_statistics["batting"] = true;
              } else {
                available_statistics["batting"] = false;
              }
              if (resData.fielding && resData.fielding.length) {
                available_statistics["fielding"] = true;
              } else {
                available_statistics["fielding"] = false;
              }
              if (resData.pitcher && resData.pitcher.length) {
                if (!available_statistics["batting"]) {
                  setSelectStatistics(1);
                }
                available_statistics["pitcher"] = true;
              } else {
                available_statistics["pitcher"] = false;
              }
              setTeamStatistics(response.data.success);
              setAvailableStatistics(available_statistics);
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });
      };
      callApi();
    } else {
      setRedirectToNotFound(true);
    }
  }, [params?.team_identifier]);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const photos = [
    {
      src: "https://source.unsplash.com/2ShvY8Lf6l0/800x599",
      width: GetRandomInt(5),
      height: 3,
    },
    {
      src: "https://source.unsplash.com/Dm-qxdynoEc/800x799",
      width: GetRandomInt(5),
      height: GetRandomInt(5),
    },
    {
      src: "https://source.unsplash.com/qDkso9nvCg0/600x799",
      width: GetRandomInt(5),
      height: GetRandomInt(5),
    },
    {
      src: "https://source.unsplash.com/iecJiKe_RNg/600x799",
      width: GetRandomInt(5),
      height: 5,
    },
    {
      src: "https://source.unsplash.com/epcsn8Ed8kY/600x799",
      width: GetRandomInt(5),
      height: GetRandomInt(5),
    },
    {
      src: "https://source.unsplash.com/NQSWvyVRIJk/800x599",
      width: GetRandomInt(5),
      height: GetRandomInt(5),
    },
  ];

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };
  const imageDataArray = () => {
    let images: any = [];
    let finalData: any = [];
    let columNumber: number = 3;
    if (
      teamStatistics.detail &&
      Object.keys(teamStatistics.detail).length &&
      teamStatistics.detail.statistics_images &&
      teamStatistics.detail.statistics_images.length &&
      teamStatistics.detail.statistics_images.split(",").length
    ) {
      // console.log("ahsdhasd", teamStatistics.detail.statistics_images.split(",").length)
      let remainingDisplayImage: number =
        teamStatistics.detail.statistics_images.split(",").length;
      let activeColumNumber: number = columNumber;
      let dividend = 0;
      let totalDisplayImages = 0;
      teamStatistics.detail.statistics_images
        .split(",")
        .map((imageData: string, imageIndex: number) => {
          if (imageIndex === totalDisplayImages && activeColumNumber !== 0) {
            if (imageIndex !== 0) {
              finalData.push(
                <div
                  className={
                    !finalData.length
                      ? "col-lg-4 col-md-12 mb-4 mb-lg-0"
                      : "col-lg-4 mb-4 mb-lg-0"
                  }
                >
                  {images}
                </div>
              );
              images = [];
            }
            let tempDividend = parseInt(
              (remainingDisplayImage / activeColumNumber).toString()
            );
            dividend = tempDividend;
            if (remainingDisplayImage / activeColumNumber > tempDividend) {
              dividend = tempDividend + 1;
            }
            activeColumNumber = activeColumNumber - 1;
            remainingDisplayImage = remainingDisplayImage - dividend;
            totalDisplayImages = totalDisplayImages + dividend;
            // console.log("kel--", dividend, activeColumNumber, remainingDisplayImage)
          }
          images.push(
            <img
              src={imageData}
              className="w-100 shadow-1-strong rounded mb-4"
              alt=""
              onClick={(e) =>
                openLightbox(e, { photo: imageData, index: imageIndex })
              }
            />
          );
          if (
            imageIndex ===
            teamStatistics.detail.statistics_images.split(",").length - 1
          ) {
            finalData.push(
              <div
                className={
                  !finalData.length
                    ? "col-lg-4 col-md-12 mb-4 mb-lg-0"
                    : "col-lg-4 mb-4 mb-lg-0"
                }
              >
                {images}
              </div>
            );
            images = [];
          }
          // if (imageIndex % 2 === 0 && imageIndex !== 0) {
          //     finalData.push(<div className={!finalData.length ? "col-lg-4 col-md-12 mb-4 mb-lg-0" : "col-lg-4 mb-4 mb-lg-0"}>{images}</div>)
          //     images = [];
          // }
          // images.push(
          //     <img
          //         src={imageData}
          //         className="w-100 shadow-1-strong rounded mb-4"
          //         alt=""
          //         onClick={(e) => openLightbox(e, { photo: imageData, index: imageIndex })}
          //     />)
          // if (imageIndex % 2 !== 0 && teamStatistics.detail.statistics_images.split(",").length - 1 === imageIndex) {
          //     finalData.push(<div className={!finalData.length ? "col-lg-4 col-md-12 mb-4 mb-lg-0" : "col-lg-4 mb-4 mb-lg-0"}>{images}</div>)
          //     images = [];
          // }
        });
    }

    return finalData;
  };

  return (
    <Fragment>
      <ProfileInfoSection isTeam={1} data={teamStatistics.detail} />
      <ProfileTabSection
        isTeam={1}
        statistics={{
          batting: teamStatistics?.batting,
          fielding: teamStatistics?.fielding,
          pitcher: teamStatistics?.pitcher,
          availableStatistics: availableStatistics,
        }}
        gallery={
          teamStatistics?.detail?.statistics_images
            ? teamStatistics?.detail?.statistics_images?.split(",")
            : []
        }
        videos={
          teamStatistics?.detail?.statistics_videos
            ? teamStatistics?.detail?.statistics_videos.split(",")
            : []
        }
        overview={teamStatistics?.detail?.team_overview}
        news={teamStatistics?.news}
        topperDetails={teamStatistics?.topperDetails}
      />
      {/* <ProfileStatisticsSimilarPlayers list={teamStatistics?.similar_players} /> */}
      <TpProfileFirstPositionAdvertise isTeam={true} />
      <ProfileStatisticsRecentStories
        story={teamStatistics?.story}
        isTeam={true}
      />
    </Fragment>
  );
}
